const LOCALE_COUNTRIES: Record<string, string> = {
  nl: "nl",
  en: "gb",
  de: "de",
  fr: "fr",
};

// Flags shipped by ./locale-flags.css. Anything outside this set falls back to
// the globe glyph instead of an empty `fi` box, since the full flag-icons
// stylesheet is no longer loaded.
const BUNDLED_FLAGS = new Set(Object.values(LOCALE_COUNTRIES));

export function LocaleFlag({ locale, className = "" }: { locale: string; className?: string }) {
  const language = locale.toLowerCase().split("-")[0];
  const region = locale.toLowerCase().split("-")[1];
  const country = region || LOCALE_COUNTRIES[language];
  if (!country || !BUNDLED_FLAGS.has(country)) return <span className={className} aria-hidden="true">🌐</span>;
  return <span className={`fi fi-${country} ${className}`.trim()} aria-hidden="true" />;
}
